// extracted by mini-css-extract-plugin
export var container = "index-module--container--1QTOe";
export var grid = "index-module--grid--2jGbQ";
export var card = "index-module--card--1VhHE";
export var intro = "index-module--intro--1f_Jb";